import { render } from "./BarcodeLabel.vue?vue&type=template&id=452125d2&scoped=true"
import script from "./BarcodeLabel.vue?vue&type=script&lang=js"
export * from "./BarcodeLabel.vue?vue&type=script&lang=js"

import "./BarcodeLabel.vue?vue&type=style&index=0&id=452125d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-452125d2"]])

export default __exports__